import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'
import { Suspense } from 'react'
import { SignIn } from '@/components/auth/signin/sign-in'
import GenieLogo from '@/components/ui/icon/icons/GenieLogo'

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
  message: z.string().optional(),
  reset: z.string().optional(),
  method: z.enum(['google', 'github', 'twitter', 'magic-link']).optional(),
  error: z.string().optional(),
})

export const Route = createFileRoute('/_auth/login')({
  validateSearch: zodValidator(loginSearchSchema),
  component: LoginPage,
})

function LoginPage() {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center">
          <div className="text-center flex flex-col items-center">
            <GenieLogo className="mb-6 h-12 w-12" />
            <p className="mb-4">Loading...</p>
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground"></div>
          </div>
        </div>
      }
    >
      <SignIn />
    </Suspense>
  )
}
